import { render } from "./OverlayDoorParams.vue?vue&type=template&id=1c7f6136&scoped=true"
import script from "./OverlayDoorParams.vue?vue&type=script&lang=js"
export * from "./OverlayDoorParams.vue?vue&type=script&lang=js"

import "./OverlayDoorParams.vue?vue&type=style&index=0&id=1c7f6136&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7f6136"]])

export default __exports__